import { useDesignMaxTheme } from "@/packages";
import { type RoomType } from "@/shared/server";
import { Center, Flex } from "@chakra-ui/react";
import { RoomDesc, RoomPhoto } from "./components";

export const RoomDetail = ({ room }: { room: RoomType }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();
    return (
        <Center position="relative" width="100%">
            <Center as="section" p={isMobile ? "48px 0 24px 0" : "120px 0"}>
                <Flex
                    p={isMobile ? "0 20px" : "0 48px"}
                    flexDir={isMobile ? "column" : "row"}
                    gap={isMobile ? "24px" : "none"}
                >
                    <RoomDesc room={room} />
                    <RoomPhoto room={room} />
                </Flex>
            </Center>
        </Center>
    );
};
